export default __webpack_public_path__ + "static/media/blue_neon_line_right.19ff3e8a.svg";